import { createContext } from "react";

import { ServiceWarningsHelper } from "@modules/billing/screens/shared-components/add-service-modal/context/ServiceWarningsHelper.ts";

export const ServiceWarningsContext = createContext<ServiceWarningsHelper>(
  {} as ServiceWarningsHelper
);
